<template>

    <form @submit.prevent="saveOwner">
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="name">{{$ml.get('Name')}}</label>
                    <input type="text" class="form-control" name="name" id="name" :placeholder="$ml.get('Name')"
                           v-model="formData.name"
                           v-validate="'required'"
                           :class="{'is-invalid': errors.has('name')}">
                </div>
            </div>
            <div class="col-12">
                <div class="form-group">
                    <label for="address">{{$ml.get('address')}}</label>
                    <input type="text" class="form-control" name="address" id="address"
                           :placeholder="$ml.get('address')" v-model="formData.address"
                           v-validate="'required'"
                           :class="{'is-invalid': errors.has('address')}">
                </div>
            </div>
            <div class="col-12">
                <div class="form-group">
                    <label for="email">{{$ml.get('email')}}</label>
                    <input type="text" class="form-control" name="email" id="email"
                           :placeholder="$ml.get('email')" v-model="formData.email"
                           :class="{'is-invalid': errors.has('email')}">
                </div>
            </div>
            <div class="col-12">
                <div class="form-group">
                    <label for="phone">{{$ml.get('phone')}}</label>
                    <input type="text" class="form-control" name="phone" id="phone"
                           :placeholder="$ml.get('phone')" v-model="formData.phone"
                           :class="{'is-invalid': errors.has('phone')}">
                </div>
            </div>
            <div class="col-12">
                <div class="form-group">
                    <label for="vat">{{$ml.get('vat')}}</label>
                    <input type="text" class="form-control" name="vat" id="vat"
                           :placeholder="$ml.get('vat')" v-model="formData.vat"
                           :class="{'is-invalid': errors.has('vat')}">
                </div>
            </div>
        </div>
        <div class="row justify-content-center align-items-center" v-if="generalError">
            <div class="col-5 form-group">
                <small class="form-text text-danger">
                    {{$ml.get('general_error_msg')}}
                </small>
            </div>
        </div>

        <div class="row" v-if="loading">
            <div class="col-12 text-center">
                <font-awesome-icon icon="spinner" size="2x" class="fa-spin"/>
            </div>
        </div>
        <div class="row" v-else>
            <div class="col-6 text-right">
                <a href="#!" class="btn btn-outline-secondary" @click.prevent="closeOwnersModal">Close</a>
            </div>
            <div class="col-6">
                <button class="btn btn-warning" type="submit">
                    {{$ml.get('Save')}}
                </button>
            </div>
        </div>

    </form>

</template>

<script>
    export default {
        name: "AddOwner",
        props: {
            owner: {
                type: Object,
                default: () => {
                    return {
                        id: null,
                        name: '',
                        address: '',
                        email: '',
                        phone: '',
                        vat: '',
                    }
                }
            }
        },
        watch: {
            owner: function (newValue, oldValue) {
                this.formData = {...newValue};
                setTimeout(() => {
                    this.errors.clear()
                }, 100)
            }
        },
        data() {
            return {
                formData: {
                    id: null,
                    name: '',
                    address: '',
                    email: '',
                    phone: '',
                    vat: '',
                },
                loading: false,
                generalError: false
            }
        },
        methods: {
            closeOwnersModal() {
                this.$emit('closeOwnersModal');
            },
            saveOwner() {
                if (!this.loading) {
                    this.generalError = false;
                    this.$validator.validateAll().then((result) => {
                        if (result) {
                            this.loading = true;
                            let ownerMethod = (this.formData.id === null) ? 'addOwner' : 'editOwner';
                            this.$store.dispatch(ownerMethod, this.formData).then(response => {
                                this.loading = false;
                                this.$emit('closeOwnersModal', response);
                            }).catch(() => {
                                this.generalError = true;
                                this.loading = false;
                            });
                        } else {
                            //set errors
                        }
                    });
                }
            }
        }
    }
</script>

<style scoped>

</style>
